
<!--@if (displayService.imageToShow$ | async; as imageURL) {-->
    <div id="imagePopup">
        <img id="popupImage" [src]="imageURL" alt="Enlarged Basemap Image" />
    </div>
<!--}-->
 <!-- [src]="displayService.imageToShow$ | async" -->